export enum GROUP_TYPE {
  PROJECT = 1,
  COMPANY = 2,
}

export const API_BASE =
  process.env.REACT_APP_API_URL || 'https://api.staging.mercator.ai/';

export const API_AUTH = process.env.REACT_APP_AUTH_SERVICE_URL || '';

export const NEW_GROUP_ID = 'new';

export const DROPDOWN_TYPES = {
  ZONES: 'Zones',
  SECTORS: 'Sectors',
};

export const TABLE_HEADINGS = {
  CITY: 'city',
  PROVINCE: 'province',
  ADDRESS: 'address',
  SECTORS: 'sectors',
  COST: 'cost',
  STATUS: 'status',
  LAST_UPDATE: 'last updated',
  EVENT_TRIGGERS: 'latest project stage',
  LATEST_COMPANY: 'company',
  CATEGORY: 'category',
  DATE_CREATED: 'date created',
};

export const getDefaultStartDate = () => {
  const currentTime = new Date();
  const day = currentTime.getDate();
  const month = currentTime.getMonth() + 1; // Months are 0-based
  const year = currentTime.getFullYear();

  return `${day}-${month}-${year - 2}`;
};

export const getDefaultEndDate = () => {
  const currentTime = new Date();
  const day = currentTime.getDate();
  const month = currentTime.getMonth() + 1;
  const year = currentTime.getFullYear();

  return `${day}-${month}-${year}`;
};

export const UTC_NOTIFICATION = {
  hr: 7,
  min: 0,
  weekDay: 0,
  monthDay: undefined,
};

export const SUPERCLUSTER_RADIUS = 75;
export const ZOOM_THRESHOLD = 15;
export const DEFAULT_MAP_ZOOM = 7;
export const MAX_MAP_ZOOM = 20;
export const PAGINATED_PROJECT_LIMIT = 20;

export const SUPPORT_EMAIL = 'support@mercator.ai';

export const DOCUMENT_IDS = {
  LAND_TITLE: 9,
};

const VERTICALS = {
  SINGLE_FAMILY_RESIDENTIAL: 58,
  TOWNHOUSE_ROW_HOUSE: 207,
};

/**
 * By default, we exclude certain residential verticals. Most of our clients don't care about them
 * and they create a lot of project noise.
 */
export const DEFAULT_VERTICAL_EXCLUSIONS = [
  VERTICALS.SINGLE_FAMILY_RESIDENTIAL,
  VERTICALS.TOWNHOUSE_ROW_HOUSE,
];

export const REGISTERED_ACCESSIBILITY_SPECIALIST_APPLICANT_TITLE =
  'Registered Accessibility Specialist';
